import { sharedTypes } from './Constants';

const initialState = {
	eventSource: '',
	sourceForUpgradeModalFromExplanation: '',
	pageSource: '',
	upgradeModalIdentifier: '',
	triggerMessagePresent: false,
	theme: 'light',
	selectedThemeOption: 'system_light',
	loadingUserCollections: false,
	userCollections: null,
	loadingSuggestedSubjects: false,
	suggestedSubjects: null,
	tfaData: null,
	loadingTFAData: false,
	loadingSubmitTFACode: false,
	websocketResponse: null,
};

export default function sharedReducer(state = initialState, action) {
	const { type, payload } = action;
	const { data, theme, selectedThemeOption } = payload || {};

	switch (type) {
		case sharedTypes.SET_EVENT_SOURCE:
		case sharedTypes.SET_FOR_UPGRADE_MODAL_FROM_EXPLANATION:
		case sharedTypes.SET_UPGRADE_MODAL_IDENTIFIER:
		case sharedTypes.SEND_EVENT_SUCCESS:
		case sharedTypes.SET_TRIGGER_MESSAGE_PRESENT:
			return {
				...state,
				...data,
			};

		case sharedTypes.SET_PAGE_SOURCE:
			return {
				...state,
				...data,
			};

		case sharedTypes.SET_THEME:
			return {
				...state,
				theme,
				selectedThemeOption,
			};

		case sharedTypes.GET_USER_COLLECTIONS:
			return {
				...state,
				loadingUserCollections: true,
			};

		case sharedTypes.GET_USER_COLLECTIONS_SUCCESS:
			return {
				...state,
				loadingUserCollections: false,
				userCollections: data,
			};

		case sharedTypes.GET_USER_COLLECTIONS_ERROR:
			return {
				...state,
				loadingUserCollections: false,
			};

		case sharedTypes.GET_USER_SUGGESTED_SUBJECTS:
			return {
				...state,
				loadingSuggestedSubjects: true,
			};

		case sharedTypes.GET_USER_SUGGESTED_SUBJECTS_SUCCESS:
			return {
				...state,
				loadingSuggestedSubjects: false,
				suggestedSubjects: data,
			};

		case sharedTypes.GET_USER_SUGGESTED_SUBJECTS_ERROR:
			return {
				...state,
				loadingSuggestedSubjects: false,
			};

		case sharedTypes.GET_TFA_DATA:
			return {
				...state,
				loadingTFAData: true,
			};
		case sharedTypes.GET_TFA_DATA_SUCCESS:
			return {
				...state,
				loadingTFAData: false,
				tfaData: data,
			};
		case sharedTypes.GET_TFA_DATA_ERROR:
			return {
				...state,
				loadingTFAData: false,
			};
		case sharedTypes.SET_TFA_CODE:
			return {
				...state,
				loadingSubmitTFACode: true,
			};
		case sharedTypes.SET_TFA_CODE_SUCCESS:
		case sharedTypes.SET_TFA_CODE_ERROR:
			return {
				...state,
				loadingSubmitTFACode: false,
			};
		case sharedTypes.CLEAR_TFA_STATE:
			return {
				...state,
				tfaData: null,
				loadingTFAData: false,
				loadingSubmitTFACode: false,
			};

		case sharedTypes.SET_WEBSOCKET_RESPONSE:
			return {
				...state,
				websocketResponse: data,
			};

		default:
			return state;
	}
}
